<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Настройка обратной связи</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Телефон для обраной связи (в формате, в котором он будет показываться в приложении)
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="phone" placeholder="example: 8 800 999-44-22" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Ссылка на whatsapp чат
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="whatsapp" placeholder="example: https://wa.me/88009994422" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Ссылка на telegram чат бот
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="telegram" placeholder="example: https://t.me/joinchat/Aa1AaAaaA1aaAAAa" />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton color="primary" @click="save()">Сохранить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { cilTrash } from '@coreui/icons';

    export default {
        name: 'FeedbackSettings',
        components: {},
        icons: {
            cilTrash,
        },

        data() {
            return {
                key: 'feedback',
                items: [],
                telegramForm: '',
                phone: '',
                whatsapp: '',
                telegram: '',
            };
        },

        mounted() {
            this.loadSettings();
        },

        methods: {
            save() {
                Vue.axios
                    .put('/settings/' + this.key, {
                        key: this.key,
                        value: {
                            telegramForm: this.telegramForm.trim(),
                            phone: this.phone.trim(),
                            whatsapp: this.whatsapp.trim(),
                            telegram: this.telegram.trim(),
                        },
                    })
                    .then(resp => {
                        this.telegramForm = resp.data.value.telegramForm;
                        this.phone = resp.data.value.phone;
                        this.whatsapp = resp.data.value.whatsapp;
                        this.telegram = resp.data.value.telegram;
                        this.$root.$emit('showAlert', 'Успешно');
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            loadSettings() {
                Vue.axios.get('/settings/' + this.key).then(resp => {
                    if (resp.data.value) {
                        this.telegramForm = resp.data.value.telegramForm;
                        this.phone = resp.data.value.phone;
                        this.whatsapp = resp.data.value.whatsapp;
                        this.telegram = resp.data.value.telegram;
                    }
                });
            },
        },
    };
</script>
